/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type WebAppWorkingHoursQueryVariables = {};
export type WebAppWorkingHoursQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"WebAppWorkingHours_viewer">;
    };
};
export type WebAppWorkingHoursQuery = {
    readonly response: WebAppWorkingHoursQueryResponse;
    readonly variables: WebAppWorkingHoursQueryVariables;
};



/*
query WebAppWorkingHoursQuery {
  viewer {
    ...WebAppWorkingHours_viewer
    id
  }
}

fragment DraggableWorkingHours_workingHours on WorkingHours {
  id
  type
  timeZone
  daySettings {
    day
    setting {
      minSlot
      maxSlot
      excludedSlots
    }
  }
  dayOverrides {
    date
    setting {
      minSlot
      maxSlot
      excludedSlots
    }
  }
}

fragment WebAppWorkingHours_viewer on Viewer {
  user {
    orgs(first: 1000000) {
      edges {
        node {
          userWorkingHours(resolveOverrides: false) {
            workingHours {
              ...DraggableWorkingHours_workingHours
              id
            }
            id
          }
          id
        }
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingSetting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedSlots",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "WebAppWorkingHoursQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "WebAppWorkingHours_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "WebAppWorkingHoursQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1000000
                                        }
                                    ],
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "resolveOverrides",
                                                                    "value": false
                                                                }
                                                            ],
                                                            "concreteType": "UserWorkingHours",
                                                            "kind": "LinkedField",
                                                            "name": "userWorkingHours",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "WorkingHours",
                                                                    "kind": "LinkedField",
                                                                    "name": "workingHours",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v0 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "type",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "timeZone",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "DaySetting",
                                                                            "kind": "LinkedField",
                                                                            "name": "daySettings",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "day",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v1 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "DayOverride",
                                                                            "kind": "LinkedField",
                                                                            "name": "dayOverrides",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "date",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v1 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v0 /*: any*/)
                                                            ],
                                                            "storageKey": "userWorkingHours(resolveOverrides:false)"
                                                        },
                                                        (v0 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v0 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v0 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "fb4958d3be50d83ea1740e0cdcb0c120",
            "id": null,
            "metadata": {},
            "name": "WebAppWorkingHoursQuery",
            "operationKind": "query",
            "text": "query WebAppWorkingHoursQuery {\n  viewer {\n    ...WebAppWorkingHours_viewer\n    id\n  }\n}\n\nfragment DraggableWorkingHours_workingHours on WorkingHours {\n  id\n  type\n  timeZone\n  daySettings {\n    day\n    setting {\n      minSlot\n      maxSlot\n      excludedSlots\n    }\n  }\n  dayOverrides {\n    date\n    setting {\n      minSlot\n      maxSlot\n      excludedSlots\n    }\n  }\n}\n\nfragment WebAppWorkingHours_viewer on Viewer {\n  user {\n    orgs(first: 1000000) {\n      edges {\n        node {\n          userWorkingHours(resolveOverrides: false) {\n            workingHours {\n              ...DraggableWorkingHours_workingHours\n              id\n            }\n            id\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '6b3ea1ccd0ee61108108bdf1cd8b77a8';
export default node;
